import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetStudentPaginatedTestStatusData, IGetDigitalStudentsPaginatedQueryVars } from '../types';

export const GET_STUDENT_PAGINATED_TEST_STATUS: TypedDocumentNode<
  IGetStudentPaginatedTestStatusData,
  IGetDigitalStudentsPaginatedQueryVars
> = gql`
  query getStudentPaginatedTestStatus($input: PaginatedStudentInput) {
    paginatedStudentTestStatus(input: $input) {
      lastKey
      students {
        id
        absent
        deniedEntry
        candRegNo
        checkedInRoom
        dapExamStatus {
          name
          timestamp
        }
        dapTestStatus {
          name
          payload {
            ... on DAPSectionStartTime {
              sectionName
            }
          }
          timestamp
        }
        estimatedExamEndTime
        examStartTime
        room {
          id
          groupTypes
          title
        }
      }
    }
  }
`;
